<template>
  <div class="page-content-wrapper choose-career-screen">
    <div class="container choose-career-screen">

      <div class="card">
        <div class="card-block">

          <div class="ex-page-content text-center">
            <span><i class="fa fa-university icon"></i></span>
            <h3 class="">Seleccioná la carrera</h3>
            <p class="text-muted">Seleccioná la carrera en la que quieres inscribirte:</p>
            <div class="alert alert-danger p-3" role="alert" v-if="error">{{ error }}</div>
            <div class="form-group col-md-4" style="margin: auto;" v-bind:class="{ 'has-danger': $v.career.$error }">
              <select id="career" class="custom-select form-control" v-model="career">
                <option v-for="career in careers" v-bind:value="career._id">
                  {{ career.name }}
                </option>
              </select>
              <div class="form-control-feedback" v-if="!$v.career.required && $v.career.$error">Seleccioná una carrera.</div>
            </div>

            <div class="alert alert-danger mt-3">
              <h5>IMPORTANTE: COHORTE 2020.</h5>
              <p><strong>No</strong> esta habilitada la carrera de TÉCNICO SUPERIOR EN DIAGNÓSTICO POR IMÁGENES para primer año.<br>
              Para los ingresantes de dicha carrera, corresponde TÉCNICO SUPERIOR EN RADIOLOGÍA.</p>
            </div>

            <!--div class="alert alert-danger mt-3 p-3" role="alert">
              <h5>ATENCIÓN: INGRESANTES 2020.</h5>
              <p><strong>Actualmente el cupo en todas las carreras se ha completado.</strong><br>
                Si de igual forma quieres inscribirte a esta carrera, serás agregado a la lista de espera.<br>
                En caso de haber vacantes, nos comunicaremos contigo al email y/o teléfono que dejes en los datos de contacto en el ultimo paso del formulario de inscripción.</p>
            </div-->

            <a class="btn btn-primary mb-5 waves-effect waves-light go-next-step" href="javascript:void(0);" @click="submit()">Continuar</a>
          </div>

        </div>
      </div>

    </div>
  </div>
</template>

<script>
  import { required } from 'vuelidate/lib/validators'

  export default {
    name: 'student-registration-step-1',


    created () {
      // Obtenemos las carreras
      this.getAllCareers()

      // Obtenemos todas las configuraciones desde el api
      this.getAllConfigurations()

      this.verifyStep1Completed()
    },


    data () {
      return {
        career: null,
        isLoading: false,
        user: this.$store.state.auth.user,
        error: null
      }
    },


    computed: {
      // carreras
      careers: function () {
        return this.$store.getters.getAllCareers
      },

      registrationToCareer: function () {
        return this.$store.getters.getRegistrationToCareer
      },

      // traemos la configuracion para saber el año lectivo actual
      configItemAcademicYear: function () {
        return this.$store.getters.getConfigByKey('registrationToCareers.academicYear')
      }
    },


    validations: {
      career: {
        required
      }
    },


    methods: {

      getAllCareers () {
        this.isLoading = true
        this.$store.dispatch('getAllCareers')
          .then((response) => {
            this.isLoading = false
          })
          .catch((response) => {
            this.isLoading = false
          })
      },


      submit: function () {

        $('.go-next-step').attr('disabled', true)

        this.$v.career.$touch()

        if(!this.$v.career.$error) {

          var self = this

          if(self.configItemAcademicYear && self.configItemAcademicYear.value) {

            const academicYear = self.configItemAcademicYear.value

            this.$store.dispatch('editRegistrationToCareer', { registrationToCareer: { academicYear: academicYear, user: self.user._id, career: self.career, studentRegistrationStatus: 'pending-step-1' } })
              .then((response) => {

                if(response.success) {

                  self.$router.push('/student-registration-step-2')

                } else {

                  self.error = response.message

                }

                $('.go-next-step').attr('disabled', false)

              })
              .catch((response) => {
                $('.go-next-step').attr('disabled', false)
              })
          }
        }
      },


      verifyStep1Completed: function () {

        var self = this

        if(self.configItemAcademicYear && self.configItemAcademicYear.value) {

          const academicYear = self.configItemAcademicYear.value

          this.$store.dispatch('getRegistrationToCareer', { registrationToCareer: { academicYear: academicYear, user: self.user._id } })
            .then((response) => {

              if (self.registrationToCareer) {
                self.career = self.registrationToCareer.career._id
              }

              if(response.data && response.data.studentRegistrationStatus) {
                if (response.data.studentRegistrationStatus != 'pending' &&
                  response.data.studentRegistrationStatus != '') {
                  return true;
                }
                return false;
              }
            })
            .catch((response) => {

            })

          return false
        }
      },


      getAllConfigurations: function () {

        var self = this

        this.$store.dispatch('getAllConfigurations')
          .then((response) => {

          })
          .catch((response) => {
            this.error = response.message
          })

      }



    }
  }
</script>

<style scoped>
  .icon {
    font-size: 47px;
    margin-bottom: 10px;
  }
  .card {
    min-height: 80vh;
  }
  .btn-primary {
    margin-top: 20px;
  }
  .ex-page-content {
    margin-top: 40px;
  }
</style>



// WEBPACK FOOTER //
// src/screens/student_registration/StudentRegistrationStep1.vue